import builder from '../builder';
import RatingStarFilled from '../../streamline-icons/light/rating-star-filled.svg';

export default builder('IconRatingStarFilledLight', RatingStarFilled);
